<template>
  <vs-popup class="holamundo validation-modal" :title="'Create simulation question in CG'" :active.sync="popupActive">
    <div>
      <div class="order-filter mb-4" v-if="cg_question_id">
        <div class="mr-2">CG link: <a :href="'https://new-content-admin-staging.embibe.com/questions/' + cg_question_id" target="_blank">{{ 'https://new-content-admin-staging.embibe.com/questions/' + cg_question_id }}</a></div>
      </div>
      <div class="order-filter">
        <div class="mr-2">Type:</div>
        <v-select
          :options="[{name: 'Drag and Drop (3D)', value: 'drag_and_drop'}, {name: 'Label the Part (3D)', value: 'label_the_part'}]"
          v-model="type"
          :clearable="false"
          label="name"
          style="width: 210px"
          :reduce="item => item.value"/>
      </div>
      <div class="order-filter mt-4">
        <div class="mr-2">Name:</div>
        <div>
          <vs-input
            name="name"
            v-validate="'required'"
            placeholder="Name"
            v-model="name"
          />
          <span class="text-danger text-sm validation-error" v-show="errors.has('name')"
                v-html="errors.first('name')"></span>
        </div>
      </div>
      <div>
        <vs-button class="mr-2 shadow-lg" type="gradient" id="save-question-btn" @click="save" style="margin-top: 10px">
          Save
        </vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import vSelect from 'vue-select'
export default {
  props: {
    asset: {
      type: Object,
      default: () => {}
    },
    variant: {
      type: Object,
      default: () => {}
    },
  },
  components: {
    vSelect
  },
  data () {
    return {
      popupActive: true,
      type: 'drag_and_drop',
      name: '',
      cg_question_id: null
    }
  },
  computed: {

  },
  mounted () {
    this.popupActive = true;
    if (this.variant.cg_question_id) {
      this.cg_question_id = this.variant.cg_question_id
    }
  },
  watch: {
    popupActive() {
      if (!this.popupActive) {
        this.closeModal();
      }
    }
  },
  methods: {
    closeModal() {
      setTimeout(() => {
        this.$emit('closeCreateQuestion', this.cg_question_id);
      }, 1)
    },
    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$root.addLoading('#save-question-btn');

          let url = '/questionincg';
          let data = {
            type: this.type,
            name: this.name,
            variant_id: this.variant._id,
            asset_id: this.asset._id,
            coobo_library_link: this.variant.coobo_library_link
          };

          this.$axios({
            method: 'post',
            url: url,
            data: data
          }).then(res => {
            this.$root.removeLoading('#save-question-btn');
            this.cg_question_id = res.data._id;
            this.$vs.notifyWrapper({
              color: 'success',
              fixed: true,
              title: 'Successfully created'
            })

          }).catch((error) => {
            console.log(error);
            this.$root.removeLoading('#save-question-btn')
            this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Validation error', text: 'Failed create question'})
          })

        } else {
          this.$vs.notifyWrapper({color: 'danger', title: 'Validation error', text: 'Fill all fields'})
        }
      })
      this.$root.addLoading('#validation-save-btn');



    }
  }
}
</script>
